// What a rhythm's stats are counted under, wherever it's shown: "rhythm:<id>" for a community
// rhythm (on the Rhythm Graph too), "graph:<id>" for the map's own rhythms (Groove MIDI, Mutopia,
// uploads, grown ideas), "book:<token>" for a book page and "book:<token>:<line>" for one of its
// exercises, and "vault:<slug>" for the Vault's drills and rudiments. A tool's uses are counted
// under "tool:<id>" (src/lib/tools/registry.js). Every idea has one address, /i/<ref> (Phase 3 of
// docs/refactor-plan.md): those, and "tree:<treeId>/<ideaId>" for an idea in a Grow tree,
// "chat:<id>" for a rhythm shared in a chat, "module:<id>" for a module, "song:<id>" for a song and
// "packet:<id>:<item>" for a rhythm kept in a band's packet (src/lib/marching/packets.js).
export const REF = /^(?:(?:rhythm|graph|book|vault|tool|chat|module|song|packet):[A-Za-z0-9_.:-]{1,120}|tree:[A-Za-z0-9_-]{1,60}\/[A-Za-z0-9_.:-]{1,60})$/;
export const isRef = (value) => typeof value === "string" && REF.test(value);

export const rhythmRef = (id) => id ? `rhythm:${id}` : null;
// A map rhythm: community rhythms are counted as themselves.
export const graphRef = (node) => !node?.id ? null : node.source === "truechops" ? rhythmRef(node.id) : `graph:${node.id}`;
export const bookPageRef = (token) => token ? `book:${token}` : null;
export const bookLineRef = (token, line) => token && line != null ? `book:${token}:${line}` : null;
const slug = (text) => String(text || "").toLowerCase().normalize("NFKD").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 60);
export const vaultRef = (category, name) => name ? `vault:${slug(category) || "drill"}.${slug(name)}` : null;
// A Vault rhythm's own address: Vault rhythms that share a name share a ref (and their stats), so the
// address says which one it is in the Vault's order after the first ("vault:drill.accent:2").
export const vaultIdea = (ref, nth = 1) => ref && nth > 1 ? `${ref}:${nth}` : ref;
export const treeRef = (treeId, ideaId = "root") => treeId ? `tree:${treeId}/${ideaId}` : null;
export const chatRef = (id) => id ? `chat:${id}` : null;
export const moduleRef = (id) => id ? `module:${id}` : null;
// An idea's page.
export const ideaHref = (ref) => ref ? `/i/${ref}` : null;
// A short fingerprint of a score's notation, to tell whether a rhythm opened in Score is still
// the same rhythm (and so still counts toward its stats).
export function scorePrint(score) {
  let value = 0x811c9dc5;
  for (const character of JSON.stringify(score?.measures || [])) { value ^= character.charCodeAt(0); value = Math.imul(value, 0x01000193) >>> 0; }
  return value.toString(36);
}
